export default {
  title: 'Presentations',
  no_results: 'There are no presentations that match your filters.',
  details: 'Details',
  poster: 'Poster',
  video: 'Video',
  slides: 'Slides',
  figures: 'Figures',
};
